import React, { useCallback, useEffect, useReducer, useState } from "react"
import {
    obterFormasPagamento,
    salvarFormasPagamento,
} from "../../../services/configuracaoFormasPagamento"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { ConfiguracaoFormasDePagamentoInicial } from "../models/configuracaoFormasDePagamentoModel"
import { ConfiguracaoFormasDePagamentoActionsTypes } from "./configuracaoFormasDePagamentoActions"
import { ConfiguracaoFormasDePagamentoContext } from "./ConfiguracaoFormasDePagamentoContext"
import { configuracaoFormasDePagamentoReducer } from "./configuracaoFormasDePagamentoReducer"

export function ConfiguracaoFormasDePagamentoContextProvider({
    children,
}: {
    children: React.ReactNode
}) {
    const [dados, dispatch] = useReducer(
        configuracaoFormasDePagamentoReducer,
        ConfiguracaoFormasDePagamentoInicial
    )
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterFormasPagamento(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar formas de pagamento")
            } else {
                setErroCarregamento(null)
                dispatch({
                    type: ConfiguracaoFormasDePagamentoActionsTypes.CARREGAR,
                    payload: { formasPagamento: response.formasPagamento },
                })
            }
        } catch {
            setErroCarregamento("Erro ao carregar formas de pagamento")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    const salvar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await salvarFormasPagamento(autorizacao, {
                formasPagamento: dados.formasPagamento,
            })
            if ("retornoErro" in response) {
                throw new Error(response.mensagem)
            }
            return response
        } finally {
            setLoading(false)
        }
    }, [dados, setLoading])

    return (
        <ConfiguracaoFormasDePagamentoContext.Provider
            value={{ dados, dispatch, erroCarregamento, salvar }}
        >
            <Loading />
            {children}
        </ConfiguracaoFormasDePagamentoContext.Provider>
    )
}
